import {ResourcePageState} from './core/services/resource-page-state.service';
import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {SiteLayoutComponent} from './core/layout/site/site-layout.component';
import {AuthGuard} from './core/guards/auth.guard';
import {UserComponent} from './features/user/user.component';
import {PageNotFoundComponent} from './core/pages/page-not-found/page-not-found.component';
import {AccessDeniedComponent} from './core/pages/access-denied/access-denied.component';
import {ErrorComponent} from './core/pages/error/error.component';
import {HomeComponent} from './features/home/home.component';
import {CurrentUserResolverService} from './core/services/current-user.resolver.service';
import {RegistrationCompletedGuard} from './core/guards/registration-completed.guard.service';
import {PrivacyComponent} from './features/privacy/privacy.component';
import {BackgroundResolverService} from './core/services/background.resolver.service';
import {NoAuthLayoutComponent} from './shared/no-auth-layout/no-auth-layout.component';
import {PrivacyContentComponent} from './features/privacy/privacy-content/privacy-content.component';
import {LandingComponent} from './core/layout/landing/landing.component';
import {RankingComponent} from './features/ranking/ranking.component';
import {NoAuthGuard} from './core/guards/no-auth.guard';
import {SearchResultsListComponent} from './core/components/search-results-list/search-results-list.component';
import {PostComponent} from "./features/post/post.component";
import {AuthStateResolver} from "./core/services/auth-state.resolver";
import {StaticPageComponent} from './features/static-page/static-page.component';
import {StaticPageResolverService} from './core/services/static-page.resolver.service';
import {ProjectAliasRedirectComponent} from './core/pages/project-alias-redirect.component';
import {SupportComponent} from './features/support/support.component';
import {MobileNotificationsComponent} from './core/pages/mobile-notifications/mobile-notifications.component';

const routes: Routes = [
  {
    path: 'instagram/callback',
    loadComponent: () => import('./features/auth/instagram-callback/instagram-callback.component').then(m => m.InstagramCallbackComponent),
  },
  {
    path: 'pages', component: NoAuthLayoutComponent, children: [
      {
        path: ':slug',
        component: StaticPageComponent,
        providers: [ResourcePageState, StaticPageResolverService],
        data: {lookup: 'publicSlug', panelClass: 'no-auth-box--static-page'},
        resolve: {
          page: StaticPageResolverService
        }
      },
    ],
    resolve: {
      background: BackgroundResolverService,
    }
  },
  {
    path: '', component: LandingComponent, canMatch: [NoAuthGuard], canActivate: [NoAuthGuard], pathMatch: 'full'
  },
  {
    path: 'landing', redirectTo: '', pathMatch: 'full'
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: '', component: SiteLayoutComponent, canActivate: [RegistrationCompletedGuard],
    children: [
      {
        path: '', component: HomeComponent, canActivate: [AuthGuard],
        data: {
          breadcrumb: 'common.home',
          disableNgxBackForwardCache: false
        }
      },
      {
        path: 'posts/:id', component: PostComponent,
        data: {
          breadcrumb: 'common.post',
        }
      },
      {
        path: 'search-results', component: SearchResultsListComponent,
        data: {
          breadcrumb: 'common.search_results'
        }
      },
      {
        path: 'tags/:slug', component: SearchResultsListComponent,
        data: {
          breadcrumb: 'common.search_results',
          mode: 'tag'
        }
      },
      {
        path: 'feed',
        loadChildren: () => import('./features/feed/feed.module').then(m => m.FeedModule),
      },
      {
        path: 'marketplace',
        loadChildren: () => import('./features/marketplace/marketplace.module').then(m => m.MarketplaceModule),
      },
      {
        path: 'chat',
        loadChildren: () => import('./features/chat/chat.module').then(m => m.ChatModule),
      },
      {
        path: 'events',
        loadChildren: () => import('./features/event/event.module').then(m => m.EventModule),
      },
      {
        path: 'places',
        loadChildren: () => import('./features/place/place.module').then(m => m.PlaceModule),
      },
      {
        path: 'vehicles',
        loadChildren: () => import('./features/vehicle-catalog/vehicle-catalog.module').then(m => m.VehicleCatalogModule),
      },
      {
        path: 'ranking',
        component: RankingComponent,
        data: {
          breadcrumb: 'common.ranking'
        }
      },
      {
        path: 'support',
        component: SupportComponent,
        data: {
          breadcrumb: 'features.support.title'
        }
      },
      {
        path: 'notifications',
        component: MobileNotificationsComponent,
        data: {
          breadcrumb: 'shared.mobile_navigation.notifications'
        }
      },
      {
        path: 'garage/:id',
        component: ProjectAliasRedirectComponent,
        data: {
          breadcrumb: 'common.project',
          disableNgxBackForwardCache: true
        }
      },
      {path: '404', component: PageNotFoundComponent},
      {path: '403', component: AccessDeniedComponent},
      {path: '500', component: ErrorComponent},
      {
        path: ':id', component: UserComponent,
        loadChildren: () => import('./features/user/user.module').then(m => m.UserModule),
      },
      {path: '**', component: PageNotFoundComponent},
    ],
    resolve: {
      currentUser: CurrentUserResolverService,
      isAuthenticated: AuthStateResolver
    }
  },
  {path: '**', component: PageNotFoundComponent}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    enableTracing: false,
    preloadingStrategy: PreloadAllModules,
    onSameUrlNavigation: 'reload',
    // scrollPositionRestoration: 'disabled',
    initialNavigation: 'enabledBlocking'
})
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
